import { put, call } from "redux-saga/effects";

import { GET_COMMONTYPE_COMPLETED,GET_COMMONTYPE_FAILED,
    GETALL_COMMONTYPE_COMPLETED,GETALL_COMMONTYPE_FAILED} from "../actions/Commontype";

import {CommontypeAPI } from "../../utils/api/CommontypeAPI";

export function* getCOMMONTYPE(request: any) { 
    try {

      //  alert("sagas getCOMMONTYPE ");
      const result = yield call(CommontypeAPI.getcommontype,request.input);

     // var status = result.data;
  
          yield put({
              type: GET_COMMONTYPE_COMPLETED,
              payload: result.data,
              input: request.input
          });        
          
      } catch (e) {        
          yield put({ type: GET_COMMONTYPE_FAILED, payload: e.message });
      }
  }

  export function* getAllCOMMONTYPE(request: any) { 
    try {

      //  alert("sagas getCOMMONTYPE ");
      const result = yield call(CommontypeAPI.getallCommontypebyInput,request.input);

   //   var status = result.data;
  
          yield put({
              type: GETALL_COMMONTYPE_COMPLETED,
              payload: result.data,
              input: request.input
          });        
          
      } catch (e) {        
          yield put({ type: GETALL_COMMONTYPE_FAILED, payload: e.message });
      }
  }